import React, { useState, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import userIcon from '../../assets/img/fileUpload/user-onboarding.png'
import mnrIcon from '../../assets/img/fileUpload/mnr.png'
import tcCreate from '../../assets/img/fileUpload/create-tc.png'
import vacantIcon from '../../assets/img/fileUpload/vacant.png'
import doorLockIcon from '../../assets/img/fileUpload/doorlock.png'
import isrIcon from '../../assets/img/fileUpload/isr.png'
import tcReadingIcon from '../../assets/img/fileUpload/tc-reading.png'
import zeroConsumptionIcon from '../../assets/img/fileUpload/zero-consumption.png'
import unbilledIcon from '../../assets/img/fileUpload/unbilled.png'
import tcTagIcon from '../../assets/img/fileUpload/tc-rr-tag.png'
import { NotifierContext } from '../../context/NotifierContext'
import { fetchUserDesignation } from '../../services/utils/meta'
import './fileUpload.scss'
import RightArrow from '../../assets/img/chevron-right.png'
import abnormalIcon from '../../assets/img/fileUpload/abnormal.png'
import subnormalIcon from '../../assets/img/fileUpload/subnormal.png'
import consumptionDcbIcon from '../../assets/img/fileUpload/consumption-dcb.png'
import psAndFeederIcon from '../../assets/img/fileUpload/ps-and-feeders.png'
import revenueDcbIcon from '../../assets/img/fileUpload/revenue-dcb.png'
import MrOnboarding from './Files/MrOnboarding/MrOnboarding'
import CreateTc from './Files/CreateTc/CreateTc'
import Vacant from './Files/Vacant/Vacant'
import VacantFileHistory from './Files/Vacant/VacantFileHistory'
import Isr from './Files/Isr/Isr'
import TcTagging from './Files/TcTagging/TcTagging'
import NoResource from './Files/NoResource'
import CreateTcFileHistory from './Files/CreateTc/CreateTcFileHistory'
import MrOnboardingFileHistory from './Files/MrOnboarding/MrOnboardingFileHistory'
import IsrFileHistory from './Files/Isr/IsrFileHistory'
import TcTaggingFileHistory from './Files/TcTagging/TcTaggingFileHistory'
import Unbilled from './Files/Unbilled/Unbilled'
import UnbilledFileHistory from './Files/Unbilled/UnbilledFileHistory'
import Mnr from './Files/Mnr/Mnr'
import MnrFileHistory from './Files/Mnr/MnrFileHistory'
import Doorlock from './Files/Doorlock/Doorlock'
import DoorlockFileHistory from './Files/Doorlock/DoorlockFileHistory'
import ZeroConsumption from './Files/ZeroConsumption/ZeroConsumption'
import ZeroConsumptionFileHistory from './Files/ZeroConsumption/ZeroConsumptionFileHistory'
import Abnormal from './Files/Abnormal/Abnormal'
import AbnormalFileHistory from './Files/Abnormal/AbnormalFileHistory'
import Subnormal from './Files/Subnormal/Subnormal'
import SubnormalFileHistory from './Files/Subnormal/SubnormalFileHistory'
import ConsumptionDcb from './Files/ConsumptionDcb/ConsumptionDcb'
import ConsumptionDcbFileHistory from './Files/ConsumptionDcb/ConsumptionDcbFileHistory'
import RevenueDcb from './Files/RevenueDcb/RevenueDcb'
import RevenueDcbFileHistory from './Files/RevenueDcb/RevenueDcbFileHistory'
import StationAndFeeders from './Files/StationAndFeeders/StationAndFeeders'
import StationAndFeedersFileHistory from './Files/StationAndFeeders/StationAndFeedersFileHistory'
import UserOnboarding from './Files/UserOnboarding/UserOnboarding'
import UserOnboardingFileHistory from './Files/UserOnboarding/UserOnboardingFileHistory'
import DatePicker from '../../components/atoms/Datepicker/DatePicker'
import Modal from '../../components/atoms/Modal/Modal'
import { auditTCs } from '../../services/api/tcAuditService'
import TcReading from './Files/TcReading/TcReading'
import TcReadingFileHistory from './Files/TcReading/TcReadingFileHistory'
import { aampleFiles, rapdrpFiles } from '../../assets/offlineData/fileData'

function useQuery () {
  return new URLSearchParams(useLocation().search)
}

const FileUploadList = (props) => {
  const notifier = useContext(NotifierContext)
  const [auditModalVisible, setAuditModalVisibility] = useState(false)
  const [auditDate, setAuditDate] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  })

  const query = useQuery()
  const history = useHistory()

  const loggedInUserDesignation = fetchUserDesignation()

  const categoriesArray = [
    ...(loggedInUserDesignation === 'ae'
      ? [{
          name: aampleFiles[0],
          slug: 'mrOnboarding',
          historySlug: 'mrOnboardingFileHistory',
          icon: userIcon,
          disabled: false
        }]
      : [{
          name: aampleFiles[1],
          slug: 'userOnboarding',
          historySlug: 'userOnboardingFileHistory',
          icon: userIcon,
          disabled: false
        }]),
    {
      name: aampleFiles[2],
      slug: 'stationAndFeeders',
      historySlug: 'stationAndFeedersFileHistory',
      icon: psAndFeederIcon,
      disabled: loggedInUserDesignation === 'ae' ? 'This feature is only for corporate office user' : false
    },
    {
      name: aampleFiles[3],
      slug: 'createTc',
      historySlug: 'createTcFileHistory',
      icon: tcCreate,
      disabled: false
    },
    {
      name: rapdrpFiles[0],
      slug: 'isr',
      historySlug: 'isrFileHistory',
      icon: isrIcon,
      disabled: false
    },
    {
      name: aampleFiles[4],
      slug: 'tcRrTag',
      historySlug: 'tcRrTaggingFileHistory',
      icon: tcTagIcon,
      disabled: false
    },
    {
      name: aampleFiles[5],
      slug: 'tcReading',
      historySlug: 'tcReadingFileHistory',
      icon: tcReadingIcon,
      disabled: false
    },
    {
      name: rapdrpFiles[1],
      slug: 'unbilled',
      historySlug: 'unbilledFileHistory',
      icon: unbilledIcon,
      disabled: false
    },
    {
      name: rapdrpFiles[2],
      slug: 'mnr',
      historySlug: 'mnrFileHistory',
      icon: mnrIcon,
      disabled: false

    },
    {
      name: rapdrpFiles[3],
      slug: 'vacant',
      historySlug: 'vacantFileHistory',
      icon: vacantIcon,
      disabled: false

    },
    {
      name: rapdrpFiles[4],
      slug: 'doorlock',
      historySlug: 'doorlockFileHistory',
      icon: doorLockIcon,
      disabled: false

    },
    {
      name: rapdrpFiles[5],
      slug: 'zeroConsumption',
      historySlug: 'zeroConsumptionFileHistory',
      icon: zeroConsumptionIcon,
      disabled: false

    }, {
      name: rapdrpFiles[6],
      slug: 'abnormal',
      historySlug: 'abnormalFileHistory',
      icon: abnormalIcon,
      disabled: false

    }, {
      name: rapdrpFiles[7],
      slug: 'subnormal',
      historySlug: 'subnormalFileHistory',
      icon: subnormalIcon,
      disabled: false

    },
    {
      name: rapdrpFiles[8],
      slug: 'consumptionDcb',
      historySlug: 'consumptionDcbFileHistory',
      icon: consumptionDcbIcon,
      disabled: false

    },
    {
      name: rapdrpFiles[9],
      slug: 'revenueDcb',
      historySlug: 'revenueDcbFileHistory',
      icon: revenueDcbIcon,
      disabled: false

    }

  ]

  const [categories] = useState(categoriesArray)
  const [loading, setLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState(categoriesArray.find(cat => (cat.slug === query.get('tab') || cat.historySlug === query.get('tab'))))

  const components = {
    noResource: NoResource,
    ...(loggedInUserDesignation === 'ae'
      ? { mrOnboarding: MrOnboarding }
      : { userOnboarding: UserOnboarding }),
    ...(loggedInUserDesignation === 'ae'
      ? { mrOnboardingFileHistory: MrOnboardingFileHistory }
      : { userOnboardingFileHistory: UserOnboardingFileHistory }),
    stationAndFeeders: StationAndFeeders,
    stationAndFeedersFileHistory: StationAndFeedersFileHistory,
    createTc: CreateTc,
    createTcFileHistory: CreateTcFileHistory,
    isr: Isr,
    isrFileHistory: IsrFileHistory,
    tcRrTag: TcTagging,
    tcRrTaggingFileHistory: TcTaggingFileHistory,
    vacant: Vacant,
    vacantFileHistory: VacantFileHistory,
    unbilled: Unbilled,
    unbilledFileHistory: UnbilledFileHistory,
    zeroConsumption: ZeroConsumption,
    zeroConsumptionFileHistory: ZeroConsumptionFileHistory,
    mnr: Mnr,
    mnrFileHistory: MnrFileHistory,
    doorlock: Doorlock,
    doorlockFileHistory: DoorlockFileHistory,
    abnormal: Abnormal,
    abnormalFileHistory: AbnormalFileHistory,
    subnormal: Subnormal,
    subnormalFileHistory: SubnormalFileHistory,
    consumptionDcb: ConsumptionDcb,
    consumptionDcbFileHistory: ConsumptionDcbFileHistory,
    revenueDcb: RevenueDcb,
    revenueDcbFileHistory: RevenueDcbFileHistory,
    tcReading: TcReading,
    tcReadingFileHistory: TcReadingFileHistory

  }

  const slug = query.get('tab') || 'mrOnboarding'

  const ComponentName = (function () {
    try {
      const activeComponent = components[query.get('tab')]
      if (activeComponent === null || activeComponent === undefined) {
        return components.noResource
      }

      return (activeComponent)
    } catch (err) {
      notifier.notifyError(err)
    }
  }())

  const redirectHandler = (slug) => {
    setSelectedFile(categoriesArray.find(cat => (cat.slug === slug || cat.historySlug === slug)))
    history.push('/file-upload?tab=' + slug)
  }

  const handleAudit = async () => {
    try {
      setLoading(true)
      const response = await auditTCs(`${auditDate.year}-${auditDate.month > 9 ? auditDate.month : `0${auditDate.month}`}`)
      notifier.notifySuccess(response.message)
    } catch (err) {
      notifier.notifyError(err)
    } finally {
      setLoading(false)
      setAuditModalVisibility(false)
    }
  }

  return (
    <>
      <div className='file-upload-content'>
        <div style={{ maxWidth: '100%' }}>
          <div className='row g-0'>
            <div className='sidebar-container'>
              <div className='tc-audit-no-list'>
                {categories.map((category, index) => {
                  return (
                    <div
                      disabled={!!category.disabled}
                      data-bs-toggle='tooltip' data-bs-placement='top' title={category.disabled}
                      key={index}
                    >
                      <div
                        onClick={() => redirectHandler(category.slug)}
                        className={`tc-audit-no-collapse ${
                          (slug === category.slug || slug === category.historySlug) ? 'active' : ''
                        } pt-3 pb-3 ps-2 pe-2`}
                      >
                        <card className='collapse-text d-flex align-items-center'>
                          <span className='iconbox'>
                            <img
                              className='img-fluid'
                              alt='missing icon'
                              src={category.icon}
                              onError={(e) => {
                                e.target.onerror = null // Prevent infinite loop in case fallback also fails
                                e.target.src = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmWru8q17zpOzzzT1s475ZS_8fOL1GS0teSw&s'
                              }}
                            />
                          </span>
                          <div className='mb-0 tc-audit-no-title ms-2'>
                            <p className='mb-1 tc-no'>{category.name}</p>
                          </div>
                          <img
                            className='img-fluid m-auto right-arrow'
                            src={RightArrow}
                            alt='missing icon'
                          />
                        </card>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className='file-upload-container'>
              <ComponentName selectedFile={selectedFile} />
              <div className={`auditButtonContainer ${loggedInUserDesignation === 'ae' ? '' : 'd-none'}`}>
                <button
                  onClick={() => setAuditModalVisibility(true)}
                  className='btn btn-primary custom-active auditButton' style={{
                    borderTopRightRadius: 0,
                    borderTopLeftRadius: 20,
                    borderBottomLeftRadius: 20,
                    borderBottomRightRadius: 0,
                    paddingLeft: 20
                  }}
                >START AUDIT
                </button>
              </div>
            </div>
          </div>
        </div>

        <Modal
          title='Select Audit Month'
          onModalClose={() => setAuditModalVisibility(false)}
          visible={auditModalVisible}
          okBtnDisabled={loading}
          okBtnLoading={loading}
          okAction={handleAudit}
        >
          <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <DatePicker
              selectedYear={auditDate.year}
              selectedMonth={auditDate.month}
              onChangeMonth={(month) => { setAuditDate({ ...auditDate, month }) }}
              onChangeYear={(year) => { setAuditDate({ ...auditDate, year }) }}
              maxDate={new Date()}
            />

          </div>

        </Modal>
      </div>
    </>
  )
}

export default FileUploadList
